import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { NeuralGlobeLogo } from "@/components/ui/logo";
import { Home, ArrowLeft } from "lucide-react";
import { SEO } from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.DEV) {
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    }
  }, [location.pathname]);

  return (
    <>
      <SEO 
        title="Page Not Found - Stefan Kaiser Consulting"
        description="The requested page could not be found. Return to Stefan Kaiser Executive Consulting for strategic IT advisory."
        noIndex={true}
      />
      <div className="min-h-screen gradient-hero flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 rounded-xl gradient-accent flex items-center justify-center shadow-glow">
            <NeuralGlobeLogo className="w-10 h-10 text-accent-foreground" />
          </div>
        </div>

        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-primary-foreground mb-4 tracking-tighter">
          404
        </h1>
        
        <h2 className="text-2xl font-semibold text-primary-foreground/90 mb-4">
          Page Not Found
        </h2>
        
        <p className="text-primary-foreground/70 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            variant="hero"
            size="lg"
            className="gap-2"
          >
            <Link to="/">
              <Home className="w-4 h-4" />
              Back to Homepage
            </Link>
          </Button>
          
          <Button
            variant="outline"
            size="lg"
            className="gap-2 bg-white/10 border-white/20 text-primary-foreground hover:bg-white/20 hover:text-primary-foreground"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
        </div>

        {/* Brand Footer */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-primary-foreground/50 text-sm">
            Stefan Kaiser · Executive Consulting
          </p>
        </div>
      </div>
      </div>
    </>
  );
};

export default NotFound;
